import { Outlet } from "react-router-dom";
import SideBar from "../../components/side-bar";

export default function Main() {
    return <SideBar>
        <Outlet />
    </SideBar>
}